@if (form && definition) {
  <div class="flex flex-col">
    <label class="soft-label top"
      >{{ definition.title }}
      @if (definition.required | booleanRule: form.value) {
        <span
          class="required-indicator"
          >*</span
          >
        }
      </label>
      <soft-file-input
        [formControl]="form|formControl:definition.name"
        [readonly]="definition.readonly | booleanRule: form.value"
        softFieldValidation
        #value
      ></soft-file-input>
    </div>
  }
